/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeDetailVo } from './CodeDetailVo';
import {
    CodeDetailVoFromJSON,
    CodeDetailVoFromJSONTyped,
    CodeDetailVoToJSON,
    CodeDetailVoToJSONTyped,
} from './CodeDetailVo';

/**
 * 
 * @export
 * @interface CommissionPartnerDetailPageItemVo
 */
export interface CommissionPartnerDetailPageItemVo {
    /**
     * 会员id
     * @type {number}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    userName?: string;
    /**
     * 用户名（登录账号）
     * @type {string}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    account?: string;
    /**
     * 登录日期（最后登录时间）
     * @type {string}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    lastLoginTime?: string;
    /**
     * 推荐码信息列表（推荐人号码/适用日期/结算信息）
     * @type {Array<CodeDetailVo>}
     * @memberof CommissionPartnerDetailPageItemVo
     */
    recommendCodes?: Array<CodeDetailVo>;
}

/**
 * Check if a given object implements the CommissionPartnerDetailPageItemVo interface.
 */
export function instanceOfCommissionPartnerDetailPageItemVo(value: object): value is CommissionPartnerDetailPageItemVo {
    return true;
}

export function CommissionPartnerDetailPageItemVoFromJSON(json: any): CommissionPartnerDetailPageItemVo {
    return CommissionPartnerDetailPageItemVoFromJSONTyped(json, false);
}

export function CommissionPartnerDetailPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionPartnerDetailPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'account': json['account'] == null ? undefined : json['account'],
        'lastLoginTime': json['lastLoginTime'] == null ? undefined : json['lastLoginTime'],
        'recommendCodes': json['recommendCodes'] == null ? undefined : ((json['recommendCodes'] as Array<any>).map(CodeDetailVoFromJSON)),
    };
}

export function CommissionPartnerDetailPageItemVoToJSON(json: any): CommissionPartnerDetailPageItemVo {
    return CommissionPartnerDetailPageItemVoToJSONTyped(json, false);
}

export function CommissionPartnerDetailPageItemVoToJSONTyped(value?: CommissionPartnerDetailPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'account': value['account'],
        'lastLoginTime': value['lastLoginTime'],
        'recommendCodes': value['recommendCodes'] == null ? undefined : ((value['recommendCodes'] as Array<any>).map(CodeDetailVoToJSON)),
    };
}

